import styled, { css } from 'styled-components';

import Placeholder from '@assets/images/promotions/promo_placeholder.webp';

export const Wrapper = styled.div<{ $bg?: string | null }>`
	width: 100%;
	min-height: 250px;
	padding: 16px;
	border-radius: 12px;
	position: relative;
	overflow: hidden;

	background-image: url(${({ $bg }) => ($bg ? $bg : Placeholder)});

	background-position: right;
	background-size: cover;
	background-repeat: no-repeat;

	display: flex;
	flex-direction: column;

	@media (max-width: 997px) {
		&:after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			width: 100%;
			height: 100%;
			z-index: 10;
			background-color: rgba(0, 0, 0, 0.4);
		}
	}
`;

export const Content = styled.div`
	position: relative;
	z-index: 20;

	height: 100%;
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: space-between;
`;

export const DateRow = styled.div`
	display: flex;
	gap: 14px;
	margin-bottom: 16px;
	align-items: center;

	@media (max-width: 997px) {
		margin-bottom: 12px;
	}
`;

export const Date = styled.div`
	font-size: 18px;
	line-height: 25px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.control.primary};
`;

export const ParticipationChip = styled.div<{ $isActive: boolean }>`
	display: inline-block;
	padding: 6px 8px;
	border-radius: 100px;
	background-color: ${({ theme }) => theme.colors.transparent.light20};

	font-size: 14px;
	line-height: 19px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	@media (max-width: 997px) {
		padding: 4px 6px;
		font-size: 12px;
		line-height: 16px;
	}

	${({ $isActive }) =>
		$isActive &&
		css`
			background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkGreen};
			color: ${({ theme }) => theme.colors.text.link};
		`}
`;

export const TextWrapper = styled.div`
	margin-bottom: 16px;
`;

export const Title = styled.h2`
	max-width: 795px;
	max-height: 76px;
	font-size: 28px;
	line-height: 38px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 12px;

	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: 997px) {
		max-height: 50px;
		font-size: 18px;
		line-height: 25px;
		margin-bottom: 10px;
	}
`;

export const Description = styled.p`
	margin: 0;
	max-width: 795px;
	max-height: 44px;

	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	overflow: hidden;
	text-overflow: ellipsis;
	white-space: wrap;

	@media (max-width: 997px) {
		max-height: 57px;
		font-size: 14px;
		line-height: 19px;
	}
`;

export const FooterWrapper = styled.div``;

export const TimerWrapper = styled.div``;

export const TimerTitle = styled.p`
	font-size: 13px;
	line-height: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.body};
	margin-bottom: 8px;
	text-transform: uppercase;
`;

export const ButtonWrapper = styled.div`
	margin-top: 16px;
`;
